import React, {useMemo} from "react";
import TestResultChart from "./TestResultChart";

/**
 * @param {{
 *   period: { levelPointsConfig?: Array<{_id:string,name:string,acceptableTypes:number[]}> } | null,
 *   testResultMap: Record<string, {result:number, nationality:number[]}> | null
 * }} props
 */
const ResultsByLevelGroups = ({period, testResultMap}) => {
    const groups = period?.levelPointsConfig || [];
    const entries = Object.values(testResultMap || {});

    // Helper: vrátí histogram [{x:body, y:count}]
    const toDataPoints = (list) => {
        const map = new Map();
        for (const r of list) {
            const x = Number(r.result) || 0;
            map.set(x, (map.get(x) || 0) + 1);
        }
        return Array.from(map.entries())
            .map(([x, y]) => ({x, y}))
            .sort((a, b) => a.x - b.x);
    };

    const charts = useMemo(() => {
        return groups.map(g => {
            const accTypes = new Set(g.acceptableTypes || []);
            const filtered = entries.filter(e => {
                const nat = Array.isArray(e.nationality) ? e.nationality : [];
                // průnik nationality a acceptableTypes
                return nat.some(n => accTypes.has(Number(n)));
            });

            const dataPoints = toDataPoints(filtered);
            const total = filtered.length;

            return (
                <div key={g._id} className="dashboard-block">
                    <h3>Výsledky testů – {g.name} (n={total})</h3>
                    <TestResultChart totalCount={total} dataPoints={dataPoints}/>
                </div>
            );
        });
    }, [groups, entries]);

    if (!groups.length) return null;

    return <>{charts}</>;
};

export default ResultsByLevelGroups;
